import Grid from '@mui/material/Grid';
import type { OverridableComponent } from '@mui/material/OverridableComponent';
import type { SvgIconTypeMap } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/system';

type IconTypographyProps = {
  Icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & { muiName: string };
  children?: React.ReactNode;
  dataTestId?: string;
  iconSx?: SxProps<Theme>;
  renderIcon?: boolean;
  spacing?: string | number;
  typographySx?: SxProps<Theme>;
};

function IconTypography({
  Icon,
  children,
  dataTestId,
  iconSx,
  renderIcon = true,
  spacing = 1,
  typographySx
}: IconTypographyProps) {
  return (
    <Grid container alignItems="center" spacing={spacing}>
      {renderIcon && (
        <Grid item>
          <Icon sx={iconSx} />
        </Grid>
      )}
      <Grid item>
        <Typography data-testid={dataTestId} sx={typographySx}>
          {children}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default IconTypography;
